export const ASSIGNEE_MODE_NAMES = ['required', 'optional', 'none'];
//# sourceMappingURL=assignee-mode-names.js.map